let merge = require('merge-recursive');

/**
 * @param {string} appName
 * @constructor
 */
export let Snippet = function (appName) {
  let defaultSnippet = {
    appId: 0,
    appName: 'Loyaltypoints',
    shopHash: '',
    product: {
      id: 0,
      variants: []
    },
    cartItems: [],
    customer: {
      id: 0,
      balance: 0,
      spent: 0,
      rewards: {
        purchase: 0,
        share: 0,
        referral: 0,
        register: 0,
        visits: 0,
        dob: 0
      },
      referrerId: ''
    },
    current_variant: {
      available: false,
      price: 0
    },
    customer_account_root: '#spurit-customer-account'
  };

  let isSnippetSet = (
      typeof(Spurit) !== 'undefined' &&
      typeof(Spurit[appName]) !== 'undefined' &&
      typeof(Spurit[appName].snippet) !== 'undefined'
  );
  let snippet = defaultSnippet;
  if (isSnippetSet) {
    snippet = merge.recursive(snippet, Spurit[appName].snippet);
  }
  for (let key in snippet) {
    this[key] = snippet[key];
  }
};